<!--<c-footer>-->
<div>
  <span> &copy; 2025 Healthbox</span>
</div>
<!--</c-footer>-->
